import { render } from "./ServicesStack.vue?vue&type=template&id=28de6591&scoped=true"
import script from "./ServicesStack.vue?vue&type=script&lang=js"
export * from "./ServicesStack.vue?vue&type=script&lang=js"

import "./ServicesStack.vue?vue&type=style&index=0&id=28de6591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28de6591"]])

export default __exports__